import React from 'react';
import { useTranslation } from 'react-i18next';

import useStudentsFormKey from '../../../hooks/use-students-form-key';
import { SimpleField } from './SimpleField';
import { StudentFieldProps } from '../../../types';

export const StudentEmailAddressField: React.FC<StudentFieldProps> = ({ index, touched }) => {
  const { t } = useTranslation('AddStudentsStep');
  const studentsFormKey = useStudentsFormKey();
  return (
    <SimpleField
      name={`${studentsFormKey}.${index}.email`}
      label={t('Email Address')}
      touched={touched}
      inputProps={{
        'aria-label': `${t('Student')} ${index + 1} ${t('Email Address')}`
      }}
    />
  );
};
